import { useSelector } from 'react-redux';
import { identity } from 'ramda';

const useCount = (countSelector = identity, countSelectorProps) => {
  return useSelector((state) => countSelector(state, countSelectorProps));
};

export default useCount;
